import { createFileRoute } from '@tanstack/react-router';
import { DonationPage } from '@/components/donations';
import { SUBSIDIARY_CODE } from '@/config';
import { useDonationEmbedResize } from '@/lib/embedResize';

// Public, UNAUTHENTICATED embed of the donor donation page — the iframe target for a campaign's
// copy-paste snippet (buildDonationEmbedSnippet). Same subsidiary-from-build + X-Subsidiary posture
// as /donate/$slug; the only difference is the trimmed embed chrome and the auto-resize reporter so
// the host iframe grows/shrinks across the 3 stages. Framing is permitted for this path via the
// Content-Security-Policy frame-ancestors header in firebase.json.
export const Route = createFileRoute('/embed/$slug')({
  component: EmbeddedDonationRoute,
});

function EmbeddedDonationRoute() {
  const { slug } = Route.useParams();
  useDonationEmbedResize(true);
  return <DonationPage subsidiary={SUBSIDIARY_CODE} slug={slug} embedded />;
}
